import {
    UPCOMING_GAMES_LOADING,
    UPCOMING_GAMES,
    UPCOMING_GAMES_INIT,
    UPCOMING_GAMES_ERROR,
} from '../../../../actions/retailerDashboard/widgets/upcomingGames/upcomingGames';

const INITIAL_STATE = {
    upcomingGamesForRetailer: undefined,
    loading: false,
    errorResponse: null,
};

const upcomingGamesWidget = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPCOMING_GAMES_INIT:
            return { ...INITIAL_STATE };
        case UPCOMING_GAMES_LOADING:
            return { ...state, loading: true };
        case UPCOMING_GAMES:
            return {
                ...state,
                upcomingGamesForRetailer: action.upcomingGamesForRetailer,
                loading: false,
                errorResponse: null,
            };
        case UPCOMING_GAMES_ERROR:
            return {
                ...state,
                loading: action.loading,
                errorResponse: action.errorResponse,
            };
        default:
            return state;
    }
};
export default upcomingGamesWidget;
